module.exports = __webpack_public_path__ + "img/visitas-registradas.30e97920.svg";